import * as _ from "lodash";
import { Pipe, PipeTransform } from "@angular/core";
import { VehiculosExclusionEntity, CabeceraVehiculosExclusionEntity } from "../entities/vehiculos_exclusion_entity";

@Pipe({
    name: "dataFilterVehiculosPlaca"
})
export class DataFilterPipeVehiculosPlaca implements PipeTransform {

    transform(array: VehiculosExclusionEntity[], query: string): any {
        if (query) {
            return _.filter(array, row => ((row.Placa + "").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
// @Pipe({
//     name: "dataFilterTitularesExclusionNombre"
// })
// export class DataFilterPipeExclusionNombre implements PipeTransform {

//     transform(array: VamTitularEntity[], query: string): any {
//         if (query) {
//             return _.filter(array, row => ((row.PrimerNombre + " " + row.SegundoNombre + " " + row.ApellidoPaterno + "" + row.ApellidoMaterno).toUpperCase()).indexOf((query.toUpperCase())) > -1);
//         }
//         return array;
//     }
// }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/solicitudes/solicitud-vehiculos.filter.ts